export default __webpack_public_path__ + "static/media/SWT0540.34I-38165_-22457_0.6af99183.jpg";